import React from 'react';

import styled from 'styled-components/macro';
import { Input, Label } from '../../AccountProfile/ProfileStyles';
import Asterix from '../../../assets/asterix.svg';
import { useTranslation } from 'react-i18next';
import InputFieldListing from './InputFieldListing';

interface NewOrganizationSampleData {
  name: string;
  phone: string;
  fax: string;
  address: string;
  city: string;
  zip: string;
  state: string;
  country: string;
  refreshTokenLifetime: any;
  authorizationCodeLifetime: any;
  accessTokenLifetime: string;
  idTokenLifeTime: string;
}

interface NonEditableFieldProps {
  label: string;
  fieldKey: string;
  required: boolean;
  formData: NewOrganizationSampleData;
  dynamicDisplayField: Function;
  subLabel?: string;
  type?: any;
  id?: any;
  tag?: any;
}
const Image = styled.img`
  width: 8px;
  height: 8px;
`;

function NonEditableFields({
  label,
  fieldKey,
  required,
  formData,
  dynamicDisplayField,
  subLabel = '',
  type,
  id,
  tag
}: NonEditableFieldProps) {
  const { t } = useTranslation();

  let explicitValue = dynamicDisplayField(formData[fieldKey as keyof NewOrganizationSampleData]);

  return (
    <>
      {tag === 'inputlisting' ? (
        <InputFieldListing
          fieldKey={fieldKey}
          type={type}
          id={id}
          label={label}
          placeholder={''}
          required={required}
          formData={formData}
          setFormData={() => {}}
          formError={{}}
          disabled={true}
        />
      ) : (
        <>
          <Label>
            {t(label)} {subLabel ? `(${t(subLabel)})` : ''}
            {required ? <Image src={Asterix} /> : ''}
          </Label>
          <Input
            value={
              formData[fieldKey as keyof NewOrganizationSampleData] !== null ||
              formData[fieldKey as keyof NewOrganizationSampleData] !== undefined
                ? explicitValue || formData[fieldKey as keyof NewOrganizationSampleData]
                : ''
            }
            readOnly={true}
            disabled={true}
          />
        </>
      )}
    </>
  );
}
const Value = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  height: 44px;
  font-family: Open Sans;
  font-size: 16px;
  line-height: 24px;
`;

export default NonEditableFields;
